export default "__VITE_ASSET__4b52e99e__"